const appointment_key = 'can-appointment'
const set_health_care_key = 'set_health_care'
const hc_user_info_key = 'hc_user_info'
const hc_access_token_key = 'hc_access_token'
const e_card_list_key = 'card'
const register_no_key = 'register_no'
const wx_info_key = 'wx_info'
const auth_token_key = 'auth_token'
const token_key = 'token'
const url_before_login_key = 'url_before_login'
const temporary_key = 'temporary'
const order_num_key = 'order_num'
const pay_method_key = 'pay_method'
const zl_order_number_key = 'zl_order_number'
const prescription_key = 'prescription'
const transit_key = 'transit'
const token_overdue_key = 'token_overdue'
const wx_login_code_key = 'wx_login_code'
const enter_medical_key = 'enter_medical'
const hc_enc_data_key = 'hc_enc_data'
const def_patient_id_key = 'def_patient_id'
const self_drug_list_key = 'self_drug_list'
const direct_access_key = 'direct_access'
const verify_order_id_key = 'verify_order_id'
const wechat_code_key = 'wechat_code'
const def_brid_key = 'def_brid'


export function removeAllStorage() {
    localStorage.removeItem(appointment_key)
    localStorage.removeItem(hc_access_token_key)
    localStorage.removeItem(e_card_list_key)
    localStorage.removeItem(register_no_key)
    localStorage.removeItem(wx_info_key)
    localStorage.removeItem(auth_token_key)
    localStorage.removeItem(token_key)
    localStorage.removeItem(temporary_key)
    localStorage.removeItem(hc_enc_data_key)
    localStorage.removeItem(def_patient_id_key)
    localStorage.removeItem(self_drug_list_key)
    localStorage.removeItem(url_before_login_key)
    localStorage.removeItem(wx_login_code_key)
}

export function setSelfDrugList(list) {
    localStorage.setItem(self_drug_list_key, JSON.stringify(list))
}

//记录自助购药选中药品
export function addToSelfDrugList(drugItem) {
    let historyList = getSelfDrugList()
    let exists = false
    historyList.forEach((item, index) => {
        if (item.id === drugItem.id) {//判断该药品是否已存在，修改选择数量
            if (drugItem.totalNum === 0) {//删除药品
                historyList.splice(index, 1)
            } else {
                item.totalNum = drugItem.totalNum
            }
            exists = true
        }
    })
    if (!exists && drugItem.totalNum > 0) {
        historyList.push(drugItem)
    }
    localStorage.setItem(self_drug_list_key, JSON.stringify(historyList))
}

//获取自助购药选中药品
export function getSelfDrugList() {
    let result = localStorage.getItem(self_drug_list_key)
    if (result)
        return JSON.parse(result)
    return []
}

/**
 * 清除选中药品
 */
export function clearSelfDrugList() {
    localStorage.removeItem(self_drug_list_key)
}

//设置默认患者id
export function setDefPatientId(id) {
    localStorage.setItem(def_patient_id_key, id)
}

//获取默认患者id（优先本地记录，否则取健康卡列表中 tacitly=1 的默认卡）
export function getDefPatientId() {
    const stored = localStorage.getItem(def_patient_id_key)
    if (stored) {
        return stored
    }
    const eCardList = getECardList()
    if (!eCardList || eCardList.length === 0) {
        return null
    }
    const defaultCard = eCardList.find(item => item.tacitly === '1')
    if (defaultCard && defaultCard.brid) {
        return defaultCard.brid
    }
    return eCardList[0].brid || null
}

export function setDirectAccess() {
    localStorage.setItem(direct_access_key, 'yes')
}

export function getDirectAccess() {
    return localStorage.getItem(direct_access_key)
}

/**
 * 获取默认患者
 */
export function getDefaultPatientInfo() {
    let eCardList = getECardList()
    if (!eCardList || eCardList.length === 0)
        return {brid: ''}
    let defBrid = getDefPatientId()
    let userInfo;
    if (defBrid) {
        userInfo = eCardList.filter(item => defBrid === item.brid);
    } else {
        userInfo = eCardList.filter(item => '1' === item.tacitly);
    }
    if (userInfo && 0 < userInfo.length) {
        let result = userInfo[0]
        return result ? result : {brid: ''}
    } else {
        let result = eCardList[0]
        return result ? result : {brid: ''}
    }
}


//记录医保加密字符串-首页
export function setEncData(encData) {
    localStorage.setItem(hc_enc_data_key, encData)
}

//记录医保加密字符串-首页
export function getEncData() {
    return localStorage.getItem(hc_enc_data_key)
}

//记录预问诊数据
export function setEnterMedical(enterMedical) {
    localStorage.setItem(enter_medical_key, enterMedical)
}

//获取预问诊数据
export function getEnterMedical() {
    let result = localStorage.getItem(enter_medical_key)
    if (result)
        return JSON.parse(result)
    return []
}

//记录微信登录code
export function setWxLoginCode(code) {
    localStorage.setItem(wx_login_code_key, code)
}

//获取微信登录code
export function getWxLoginCode() {
    return localStorage.getItem(wx_login_code_key)
}

//获取是否可以预约
export function getCanAppointment() {
    return localStorage.getItem(appointment_key)
}

//设置是否可预约
export function setCanAppointment(canAppointment) {
    localStorage.setItem(appointment_key, canAppointment)
}

//标记是否从医保APP进入
export function setHealthCare() {
    localStorage.setItem(set_health_care_key, '1')
}

//获取是否从医保APP进入
export function getHealthCare() {
    return localStorage.getItem(set_health_care_key)
}

export function clearHealthCare() {
    localStorage.removeItem(set_health_care_key)
}

//保存医保用户信息
export function setHcUserInfo(hcUserInfo) {
    localStorage.setItem(hc_user_info_key, hcUserInfo)
}

export function clearHcUserInfo() {
    localStorage.removeItem(hc_user_info_key)
}

//获取医保用户信息
export function getHcUserInfo() {
    return JSON.parse(localStorage.getItem(hc_user_info_key))
}

//保存医保token
export function setHcToken(token) {
    localStorage.setItem(hc_access_token_key, token)
}

//获取医保token
export function getHcToken() {
    return localStorage.getItem(hc_access_token_key)
}

//保存电子健康卡
export function setECardList(eCardList) {
    localStorage.setItem(e_card_list_key, eCardList)
}

//获取电子健康卡
export function getECardList() {
    let eCardStr = localStorage.getItem(e_card_list_key)
    if (eCardStr)
        return JSON.parse(eCardStr)
    else return []
}

//保存从健康雅安跳转传入的registerNo
export function setRegisterNo(registerNo) {
    localStorage.setItem(register_no_key, registerNo)
}

//获取从健康雅安跳转传入的registerNo
export function getRegisterNo() {
    return localStorage.getItem(register_no_key)
}

// 微信登录用户信息
export function getWxInfo() {
    const user = localStorage.getItem(wx_info_key)
    if (user) {
        return JSON.parse(user)
    }
    return {}
}

//设置微信登录用户信息
export function setWxInfo(user) {
    return localStorage.setItem(wx_info_key, JSON.stringify(user))
}

// 记录后端鉴权 JWT（Authorization）
export function setAuthToken(token) {
    localStorage.setItem(auth_token_key, token)
}

// 获取后端鉴权 JWT
export function getAuthToken() {
    return localStorage.getItem(auth_token_key)
}

// 清除后端鉴权 JWT
export function clearAuthToken() {
    localStorage.removeItem(auth_token_key)
}

//记录token（中联token）
export function setToken(token) {
    localStorage.setItem(token_key, token)
}

//获取token（中联token）
export function getToken() {
    return localStorage.getItem(token_key)
}

//记录temporary
export function setTemporary(temporary) {
    localStorage.setItem(temporary_key, temporary)
}

//获取temporary
export function getTemporary() {
    let msg = localStorage.getItem(temporary_key)
    if (msg)
        return JSON.parse(msg)
    return {}
}

//清空temporary
export function clearTemporary() {
    localStorage.removeItem(temporary_key)
}

//记录订单号
export function setOrderNum(orderNum) {
    localStorage.setItem(order_num_key, orderNum)
}

//获取订单号
export function getOrderNum() {
    return localStorage.getItem(order_num_key)
}

//清空订单号
export function clearOrderNum() {
    localStorage.removeItem(order_num_key)
}

//记录支付方式
export function setPayMethod(payMethod) {
    localStorage.setItem(pay_method_key, payMethod)
}

//获取支付方式
export function getPayMethod() {
    return localStorage.getItem(pay_method_key)
}

//清空支付方式
export function clearPayMethod() {
    localStorage.removeItem(pay_method_key)
}

//记录医药机构订单号
export function setZlOrderNumber(zlOrderNumber) {
    localStorage.setItem(zl_order_number_key, zlOrderNumber)
}

//获取医药机构订单号
export function getZlOrderNumber() {
    return localStorage.getItem(zl_order_number_key)
}

//清空医药机构订单号
export function clearZlOrderNumber() {
    localStorage.removeItem(zl_order_number_key)
}

//记录处方
export function setPrescription(prescription) {
    localStorage.setItem(prescription_key, prescription)
}

//获取处方
export function getPrescription() {
    let prescription = localStorage.getItem(prescription_key)
    if (prescription)
        return JSON.parse(prescription)
    return {}
}

//清空处方
export function clearPrescription() {
    localStorage.removeItem(prescription_key)
}

//记录该跳转挂号记录页还是处方记录页(1：挂号；2:处方)
export function setTransit(flag) {
    localStorage.setItem(transit_key, flag)
}

//获取该跳转挂号记录页还是处方记录页
export function getTransit() {
    return localStorage.getItem(transit_key)
}

//记录token过期时间
export function setTokenOverdueTime(time) {
    localStorage.setItem(token_overdue_key, time)
}

//获取token是否过期
export function getIsTokenOverdue() {
    const time1 = new Date();
    const time2 = new Date(localStorage.getItem(token_overdue_key));
    return time1.getTime() >= time2.getTime();
}



/**
 * 设置微信身份码
 * @param wechatCode
 */
export function setWechatCodeStorage(wechatCode) {
    localStorage.setItem(wechat_code_key, wechatCode)
}

/**
 * 设置微信身份码
 * @returns {string}
 */
export function getWechatCodeStorage() {
    return localStorage.getItem(wechat_code_key)
}

/**
 * 设置实人认证orderId
 * @param verifyOrderId
 */
export function setVerifyOrderId(verifyOrderId) {
    localStorage.setItem(verify_order_id_key, verifyOrderId)
}

/**
 * 获取实人认证orderId
 * @returns {string}
 */
export function getVerifyOrderId() {
    return localStorage.getItem(verify_order_id_key)
}

/**
 * 记录默认病人ID
 * @param brid 病人ID
 */
export function setDefBrid(brid) {
    localStorage.setItem(def_brid_key, brid)
}

/**
 * 获取默认病人ID
 * @returns {string}
 */
export function getDefBrid() {
    return localStorage.getItem(def_brid_key)
}

/** 报告页：放弃认证后本 webview 内不再自动拉起 */
export const REPORT_AUTH_SKIP_KEY = 'report_auth_skipped'
/** 报告页：已跳转外部认证，待回跳（localStorage，跨域可保留） */
export const REPORT_VERIFY_PENDING_KEY = 'report_verify_pending'

/**
 * 从首页等入口再次进入报告查询时清除放弃/进行中标记，以便重新拉起认证
 */
export function clearReportAuthFlags() {
    sessionStorage.removeItem(REPORT_AUTH_SKIP_KEY)
    localStorage.removeItem(REPORT_VERIFY_PENDING_KEY)
}

// 获取登录前的 url
export function getUrlBeforeLogin() {
    return localStorage.getItem(url_before_login_key)
}

// 记录登录前的 url
export function setUrlBeforeLogin(url) {
    localStorage.setItem(url_before_login_key, url)
}

// 清除登录前的 url，避免复用上一次会话留下的路径
export function clearUrlBeforeLogin() {
    localStorage.removeItem(url_before_login_key)
}

// 清除已使用的微信登录 code
export function clearWxLoginCode() {
    localStorage.removeItem(wx_login_code_key)
}



// WEBPACK FOOTER //
// ./src/utils/storage.js